const privacyPolicy = {
  id: 'privacy-policy-en',
  title: 'Privacy policy',
  body: `
    <h2>Privacy Policy</h2>
    <h4>General Statement</h4>
    <p>
      This Privacy Policy relates to the privacy practices of
      <b>BROADMIND LIMITED</b> (hereinafter referred to as “<b>BL</b>” or
      “<b>we</b>” or “<b>us</b>”) in connection with the Website
      www.super-ego.info(hereinafter referred to as the “<b>Website</b>”).
    </p>
    <p>
      BL fully respects your right to privacy and actively seeks to preserve the
      privacy rights of those who share information on the Website. Any personal
      data and information which you volunteer to BL will be treated with the
      highest standards of security and confidentiality, in accordance with Irish
      and European Data Protection legislation. BL shall process your personal data
      and information in accordance with the General Data Protection Regulation (EU)
      2016/679 and the Data Protection Act 2018.
    </p>
    <p>
      We will ensure that your data is processed fairly and lawfully in keeping with
      the principles of data protection and will process personal data and
      information under various legal bases depending on the purpose for which the
      data is collected, including:
    </p>
    <ul>
      <li>
        Where the processing of personal data and information is necessary for the
        formation of a contract with you;
      </li>
      <li>
        Where the processing of personal data and information is based on legitimate
        interests e.g. for the administration of events and the use of our services;
      </li>
      <li>
        Generally, when using personal data and information we will seek consent for
        the processing of data except where another condition applies e.g. legal
        claims or medical diagnosis.
      </li>
    </ul>

    <h4>What types of information we collect?</h4>
    <p>
      Consent to the processing of personal data and information pursuant to this
      Privacy Policy is given by filling in the respective registration form on the
      Website, tick the box to agree and clicking on “Accept” button.
    </p>
    <p>
      BL collects and processes the following personal data related to users, who
      have registered on the Website: (i) first name, (ii) e-mail address, (iii)
      telephone number, (iv) mailing address (city/town).
    </p>
    <p>
      We also collects (v) technical information, including the Internet protocol
      (IP) address used to connect users computer to the Internet, (vi) login
      information, (vii) browser type and version, (viii) time zone setting, (ix)
      browser plug-in types and versions, (x) operating system and platform; (xi)
      data about users browsing (types of content consumed and browsing patterns)
    </p>
    <p>
      <u>Giving the above consent is entirely voluntary</u>, although it is a
      condition for getting an access to the Master Kit product.
    </p>
    <p>
      Inter alia, we collect additional personal data and information for the
      purposes of formation and administration of contracts, including Master Kit
      Software License Agreements and when you register to use other services on the
      Website e.g. Agency Agreement.
    </p>
    <p>
      The above additional data is provided by the User voluntarily and may include:
      (vi) the User’s surname, (vii) the User’s full mailing address.
    </p>
    <p>
      We may add your personal data to a relevant mailing list, if you have made an
      enquiry in relation to a service, if Master Kit Software License Agreement
      entered into force and/or respective transaction has taken place or if you
      have specifically requested to be added to a mailing list in order to receive
      information which is of interest to you. In the event that we do record your
      data on a mailing list you will be provided with the opportunity to opt out
      from the outset and in all our communications with you and we will only send
      you information relevant to your initial enquiry or transaction. If you don’t
      want to receive our regular letters, you can refuse mailout at any time via a
      special link located at the end of each letter.
    </p>

    <h4>How and why we collect personal data and information?</h4>
    <p>
      It is
      <u
        ><b>NOT</b> used to gather identifiable personal information on individual
        website visitors</u
      >, except in so far as this is permitted by law and may be necessary in order
      to prevent or detect problems or offences in relation to the operation of the
      website.
    </p>
    <p>
      The data we collect from you will be used by BL in accordance with the
      purposes outlined in this Privacy Policy.
    </p>
    <p>We collect personal data and information via:</p>
    <ul>
      <li>Website forms</li>
      <li>written application forms and documents</li>
      <li>email</li>
      <li>surveys.</li>
    </ul>
    <p>
      We principally use your personal data and information under the legal basis of
      consent.
      <u>Please note that you are free to withdraw your consent at any time</u>. BL
      may also process your personal data and information under the legal basis of
      contract whereby the processing is necessary for a software license or any
      other contract you have with BL, or because you have asked us to take specific
      steps before entering into a contract.
    </p>
    <p>
      We routinely collect technical information (vide supra). This information is
      used to ensure the smooth running of the computer network and for statistical
      or administrative purposes. This allows us to ensure that content from our
      Website is presented in the most effective manner for you and for your
      computer. The use of your personal data and information in the above ways is
      necessary for the legitimate interests of BL in operating and improving the
      Website. For more information please review our
      <a href="/?activeDocKey=cookiesStatement&showLegal=true" target="_blank"
        >Cookies Statement</a
      >
    </p>
    <p>
      BL shall only process personal data and information in line with the purpose
      for which you provided it to the extent necessary to provide you with the
      information or service you require.
    </p>
    <p>
      BL shall not disclose your personal data nor information to third parties
      unless you are specifically informed otherwise or we require a third party
      contractors to process the personal data and information on our behalf (in
      which case BL requires these third parties to comply with its instructions and
      we require that they do not use your personal data and information for their
      own business purposes, unless you have explicitly consented to the use of your
      personal data and information in this way).
    </p>

    <h4>How we store and secure your data</h4>
    <p>
      Any data we collect from you will be stored confidentially and securely. In
      keeping with the data protection principles, we will only store your data for
      as long as is necessary. As a matter of course, we will delete personal data
      associated with accounts that have been inactive for at least 6 years.
    </p>
    <p>
      When we store your personal data and information on our systems the data will
      primarily be stored within the European Economic Area (EEA) which are also
      subject to European data protection requirements.
    </p>
    <p>
      <b
        >We may store or share your data outside the EEA in the following
        circumstances:</b
      >
    </p>
    <p></p>
    <ul>
      <li>
        For processing international applications and sharing data with partner
        company.
      </li>
      <li>
        When using cloud services for the secure storage of data. Some cloud service
        providers store data in international data centers e.g. the US. We will only
        use services which are compliant with the European General Data Protection
        Regulation and who satisfy the conditions for processing personal data
        outside the EEA.
      </li>
      <li>For other purposes where we have your explicit consent to do so.</li>
      <li>If we are required to do so by law.</li>
    </ul>

    <h4>Details of third parties with whom we share personal data</h4>
    <p>
      We will share your data with third parties where necessary for purposes of the
      processing and where there is a legal basis to do so. BL may share relevant
      personal data and information with the following categories of third parties:
    </p>
    <ul>
      <li>State or regulatory bodies of Ireland or EEA.</li>
      <li>
        IT or cloud service providers that provide essential services to BL e.g.
        Google.
      </li>
      <li>
        Firms that provide professional services to BL such as legal advisers.
      </li>
      <li>
        Firms that provide archiving and storage and disposal of confidential waste.
      </li>
      <li>Firms that update the content of Master Kit product</li>
    </ul>
    <p>
      When we share your data with the third parties listed above BL will endeavour
      only to share the data that is needed, that the data is only processed
      according to our specific instructions and that the same standards and level
      of confidentiality and security are maintained. Once the processing of the
      data is complete any third parties with whom data was shared will be required
      to return the data to BL save where they are required to retain it by law.
    </p>
    <p>
      We also work with third party contractors, some of whom operate and host data
      outside EEA. Accordingly, in the course of processing your personal data, it
      may be transferred outside of the EEA on the understanding that we rely on
      legally approved mechanisms to lawfully transfer data across borders.
    </p>

    <h4>Your Rights</h4>
    <p>
      You have various rights under applicable data protection laws, subject to
      certain exemptions, in connection with our processing of your personal data
      and information, including the right:
    </p>
    <table>
      <thead>
        <tr>
          <th>RIGHT</th>
          <th>DESCRIPTION</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Inspection and access</td>
          <td>
            Allows you to request a summary and/or a copy of your personal data and
            information which we process or which is processed on our behalf
            together with details about the way in which we process your personal
            data and information.
          </td>
        </tr>
        <tr>
          <td>Rectification</td>
          <td>
            Allows you to request that any inaccurate personal data and information
            be rectified.
          </td>
        </tr>
        <tr>
          <td>Erasure (right to be forgotten)</td>
          <td>
            In certain circumstances, allows you to request that personal data and
            information be deleted.
          </td>
        </tr>
        <tr>
          <td>Restriction</td>
          <td>
            Allows you to request that processing of your personal data and
            information be restricted.
          </td>
        </tr>
        <tr>
          <td>Portability</td>
          <td>
            Allows you to request that BL transmits either to you or to another
            controller certain personal data and information that you have provided
            to BL.
          </td>
        </tr>
        <tr>
          <td>Objection</td>
          <td>
            Allows you to object data processing being carried out by BL, in which
            case BL has to put on hold such processing.
          </td>
        </tr>
        <tr>
          <td>Automated decision- making</td>
          <td>
            You have a right not to be subject to certain forms of automated
            decision- making, provided such decision produces legal effects or
            similarly significantly affects you and where there is no human input
            involved.
          </td>
        </tr>
      </tbody>
    </table>
    <p>
      If you wish to avail of any of the rights set out above, please write to:
      BROADMIND LIMITED HE 394653 Boumpoulinas, 1-3 BOUBOULINA BUILDING, 4th floor,
      Flat/Office42 1060, Nicosia, Cyprus (or email info@super-ego.info).
    </p>
    <p>
      Please note that you may be asked to provide proof of identity, e.g. copy of
      passport or driving license. Copies are acceptable in most cases; however, we
      reserve the right to ask to see original documents where necessary. Copies of
      such documents will be securely destroyed once we have verified your identity.
    </p>
    <p>
      To help us to respond to your request properly, please be as specific as
      possible e.g. if you wish to avail of your right to access your personal data,
      please specify the personal data of which you wish to obtain a copy.
    </p>
  `,
}

export default privacyPolicy
